module.exports = __webpack_public_path__ + "static/back2-47eecc8a6696dce72fe72d575f184733.png";